// Mock data for Arvanta Solutions

export const COMPANY = {
  name: 'Arvanta Solutions',
  tagline: 'Tender Bidding & Digital Growth',
  email: 'info@arvantasolutions.in',
  phone: '+91 72848 25958',
  phoneHref: '+917284825958',
  address: '305, Opal Square, Behind Express Hotel, Alkapuri, Vadodara 390007',
  addressShort: 'Alkapuri, Vadodara',
};

export const HERO_STATS = [
  { value: '250+', label: 'Tenders Won', icon: 'Trophy', color: 'amber' },
  { value: '₹165Cr+', label: 'Bid Value', icon: 'IndianRupee', color: 'blue' },
  { value: '94%', label: 'Success Rate', icon: 'BarChart3', color: 'amber' },
];

export const RESULTS_STATS = [
  {
    value: 250,
    suffix: '+',
    label: 'Tenders Won',
    desc: 'Across government & private sector',
    icon: 'Trophy',
    color: 'amber',
  },
  {
    value: 165,
    prefix: '₹',
    suffix: 'Cr+',
    label: 'Bid Value Secured',
    desc: 'Total awarded bid value',
    icon: 'BadgeIndianRupee',
    color: 'blue',
  },
  {
    value: 94,
    suffix: '%',
    label: 'Bid Success Rate',
    desc: 'Industry-leading win ratio',
    icon: 'TrendingUp',
    color: 'green',
  },
  {
    value: 35,
    suffix: '+',
    label: 'Clients Served',
    desc: 'SMEs and large enterprises',
    icon: 'Users',
    color: 'purple',
  },
];

// Impact Snapshot — richer, credibility-loaded presentation
export const IMPACT = {
  focal: {
    metric: '94%',
    label: 'Qualified-Bid Success Rate',
    desc: 'Of opportunities we choose to bid on, we win ~3 out of every 4 — more than 3× the typical industry benchmark.',
    industryAvg: 28,
    ours: 94,
  },
  supporting: [
    {
      value: '250+',
      label: 'Tenders Won',
      sub: 'Across Govt, PSU & private',
      icon: 'Trophy',
      color: 'amber',
    },
    {
      value: '₹165Cr+',
      label: 'Bid Value',
      sub: 'Cumulative awarded value',
      icon: 'BadgeIndianRupee',
      color: 'blue',
    },
    {
      value: '35+',
      label: 'Active Clients',
      sub: 'SMEs to large enterprises',
      icon: 'Users',
      color: 'purple',
    },
  ],
  trustStrip: [
    { label: 'Operating Since 2020', icon: 'CalendarCheck' },
    { label: '20+ Sectors Served', icon: 'Layers' },
    { label: '4 States Coverage', icon: 'MapPin' },
    { label: 'NDA-Protected Engagements', icon: 'ShieldCheck' },
  ],
  recentWins: [
    { amount: '₹50L+', sector: 'HCL — Chemicals', when: 'Last 6 months', accent: 'green' },
    { amount: '₹4Cr+', sector: 'Flameproof LED', when: '12-month engagement', accent: 'amber' },
    { amount: '₹2.5Cr+', sector: 'Stud Bolts & Fasteners', when: '8 tenders won', accent: 'amber' },
    { amount: '₹11.4Cr', sector: 'Engineering & Infra', when: 'Q3 — Govt contract', accent: 'purple' },
    { amount: '₹85L', sector: 'Pharma Procurement', when: 'Last quarter', accent: 'blue' },
    { amount: '₹1.2Cr', sector: 'Industrial Supplies', when: 'This month', accent: 'green' },
    { amount: '₹64L', sector: 'Water-Treatment Plant', when: 'Last month', accent: 'blue' },
    { amount: '₹38L', sector: 'IT Hardware Supply', when: 'Yesterday', accent: 'amber' },
  ],
  sectors: [
    'Construction',
    'Infrastructure',
    'Information Technology',
    'Chemicals',
    'Healthcare',
    'Logistics',
    'Energy & Power',
    'Pharmaceuticals',
    'Engineering Services',
    'Manufacturing',
    'D2C Brands',
    'Fasteners & Hardware',
    'Industrial Lighting',
    'Water Treatment',
    'Defence & Aerospace',
    'Renewables & Solar',
    'Education & EdTech',
    'Food Processing',
    'Textiles & Apparel',
    'Automotive Components',
    'Telecommunications',
    'Hospitality',
  ],
};

export const SERVICE_CARDS = [
  {
    id: 'tender',
    anchor: 'tender-bidding',
    tag: 'Core Service',
    tagColor: 'amber',
    title: 'Tender Bidding Solutions',
    desc: 'End-to-end tender management for government, PSU, and private sector opportunities — strategy, writing, compliance, submission, and post-bid follow-up.',
    icon: 'FileCheck2',
    color: 'amber',
    bullets: [
      'Tender identification & tracking across 50+ portals',
      'Bid writing & technical / financial documentation',
      'Compliance checks & eligibility validation',
      'End-to-end submission management',
      'Post-bid follow-up & liaison support',
    ],
    cta: 'Get a Quote',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=1600&auto=format&fit=crop',
  },
  {
    id: 'digital',
    anchor: 'digital-growth',
    tag: 'Growth',
    tagColor: 'blue',
    title: 'Digital Growth Services',
    desc: 'Full-funnel digital growth engineered for B2B — organic search, paid campaigns, and lead-gen systems that compound every quarter.',
    icon: 'TrendingUp',
    color: 'blue',
    bullets: [
      'SEO strategy & content marketing',
      'Google Ads & social media campaigns',
      'B2B lead generation funnels',
      'Brand visibility for enterprise audiences',
      'Analytics dashboards & monthly reporting',
    ],
    cta: 'Get a Quote',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1600&auto=format&fit=crop',
  },
  {
    id: 'webdev',
    anchor: 'website-development',
    tag: null,
    tagColor: 'emerald',
    title: 'Website Development',
    desc: 'Custom-built websites that load fast, rank high, and convert visitors into qualified leads — crafted on modern React / Next.js stacks.',
    icon: 'Code2',
    color: 'emerald',
    bullets: [
      'Corporate websites & brand sites',
      'High-converting landing pages',
      'E-commerce storefronts',
      'Portfolio & case-study sites',
      'Mobile-first, SEO-ready, lightning-fast',
    ],
    cta: 'Get a Quote',
    image: 'https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?q=80&w=1600&auto=format&fit=crop',
  },
  {
    id: 'software',
    anchor: 'custom-software',
    tag: null,
    tagColor: 'violet',
    title: 'Customized Business Softwares',
    desc: 'Bespoke software that automates your operations — ERP, CRM, inventory, billing, and workflow systems built around how your business actually runs.',
    icon: 'Boxes',
    color: 'violet',
    bullets: [
      'ERP & CRM development',
      'Inventory management systems',
      'Billing & invoicing platforms',
      'Custom workflow automation',
      'Tally / SAP / Zoho integrations',
    ],
    cta: 'Get a Quote',
    image: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?q=80&w=1600&auto=format&fit=crop',
  },
];

export const FULL_SUPPORT = {
  title: 'Full-Spectrum Support & Compliance',
  desc: 'Legal documentation, compliance review, digital audit, and post-award management — we handle the complexity so you can focus on delivery.',
  cta: 'Learn More',
  image: 'https://images.pexels.com/photos/9487242/pexels-photo-9487242.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1400',
};

export const METHODOLOGY = [
  {
    num: '01',
    title: 'Opportunity Intelligence',
    desc: 'We monitor 50+ tender portals daily and filter opportunities that match your capabilities, ensuring you never miss a high-probability bid.',
  },
  {
    num: '02',
    title: 'Precision Bid Crafting',
    desc: 'Our team of expert bid writers, technical specialists, and pricing analysts collaborate to build proposals that resonate with evaluation committees.',
  },
  {
    num: '03',
    title: 'Digital Presence Engineering',
    desc: 'We engineer your online presence with data-driven SEO, conversion-focused content, and strategic ad campaigns that compound over time.',
  },
  {
    num: '04',
    title: 'Post-Award Management',
    desc: 'Beyond the win — contract management, compliance documentation, and ongoing support to ensure successful delivery and long-term relationships.',
  },
];

export const METHODOLOGY_BADGES = [
  { label: 'Dedicated Account Manager', icon: 'UserCircle' },
  { label: '48-Hour Bid Turnaround', icon: 'Clock' },
  { label: 'Govt & Private Sector Expertise', icon: 'ShieldCheck' },
  { label: 'Transparent Reporting', icon: 'FileText' },
];

// Anonymized case studies — no client names, only industry & verified outcomes
export const CASE_STUDIES = [
  {
    id: 1,
    category: 'Tender Bidding',
    industry: 'Flameproof LED Manufacturer',
    region: 'Western India',
    metric: '₹4Cr+',
    metricLabel: 'Contract Secured',
    summary:
      'A flameproof LED manufacturer scaled their tender win rate significantly after onboarding our bid-writing, technical compliance and pricing strategy team — securing high-value contracts across hazardous-area lighting categories.',
    highlights: [
      { k: 'Win Rate', v: '30% → 75%' },
      { k: 'Avg. Bid Size', v: '₹85L' },
      { k: 'Engagement', v: '12 Months' },
    ],
    icon: 'Lightbulb',
    accent: 'amber',
  },
  {
    id: 2,
    category: 'Tender Bidding',
    industry: 'HCL (Hydrochloric Acid) Manufacturer',
    region: 'Gujarat',
    metric: '₹50L+',
    metricLabel: 'Orders Secured · Last 6 Months',
    summary:
      'A hydrochloric acid manufacturer accelerated business growth through targeted tender participation — securing ₹50 Lac+ in orders over the last 6 months across chemical procurement, water-treatment, and industrial supply tenders.',
    highlights: [
      { k: 'Orders Secured', v: '₹50L+' },
      { k: 'Period', v: 'Last 6 Months' },
      { k: 'Sectors', v: 'Chem · Water · Industrial' },
    ],
    icon: 'FlaskConical',
    accent: 'green',
  },
  {
    id: 3,
    category: 'Digital Growth',
    industry: 'Logistics SaaS',
    region: 'Bengaluru',
    metric: '+280%',
    metricLabel: 'Organic Traffic Growth',
    summary:
      'A B2B logistics technology platform achieved a 280% surge in organic traffic and started generating qualified enterprise leads through SEO within 6 months of engagement.',
    highlights: [
      { k: 'Keywords Ranked', v: '420+' },
      { k: 'Domain Authority', v: '24 → 51' },
      { k: 'Lead Quality', v: 'Enterprise' },
    ],
    icon: 'TrendingUp',
    accent: 'blue',
  },
  {
    id: 4,
    category: 'Tender Bidding',
    industry: 'Stud Bolt & Fasteners Company',
    region: 'North India',
    metric: '8 Tenders',
    metricLabel: 'Won — ₹2.5Cr+ Contract Value',
    summary:
      'A stud bolt and industrial fasteners manufacturer secured 8 tenders with a combined contract value of ₹2.5Cr+ across central PSUs and state authorities — backed by our pricing strategy and technical proposal expertise.',
    highlights: [
      { k: 'Tenders Won', v: '8' },
      { k: 'Total Value', v: '₹2.5Cr+' },
      { k: 'Sectors', v: 'PSU + State' },
    ],
    icon: 'Wrench',
    accent: 'amber',
  },
  {
    id: 5,
    category: 'Digital Growth',
    industry: 'B2B SaaS',
    region: 'Pune',
    metric: '−60%',
    metricLabel: 'CAC Reduction',
    summary:
      'A growing SaaS company reduced customer acquisition cost by 60% while tripling qualified leads through our integrated paid-ads, SEO, and CRO playbook.',
    highlights: [
      { k: 'CAC', v: '−60%' },
      { k: 'Qualified Leads', v: '3.2×' },
      { k: 'ROAS', v: '4.7×' },
    ],
    icon: 'LineChart',
    accent: 'green',
  },
  {
    id: 6,
    category: 'Tender Bidding',
    industry: 'Engineering & Infra',
    region: 'Gujarat',
    metric: '4 Months',
    metricLabel: 'To First Win',
    summary:
      'An engineering services firm went from zero tender wins to a major government contract in 4 months — supported by full-spectrum compliance review and bid strategy.',
    highlights: [
      { k: 'Time to Win', v: '4 Months' },
      { k: 'First Contract', v: '₹11.4Cr' },
      { k: 'Compliance', v: 'Zero issues' },
    ],
    icon: 'ShieldCheck',
    accent: 'purple',
  },
  {
    id: 7,
    category: 'Digital Growth',
    industry: 'D2C Manufacturing',
    region: 'Vadodara',
    metric: '+138%',
    metricLabel: 'Revenue Growth',
    summary:
      'A direct-to-consumer manufacturer grew online revenue 138% YoY through a coordinated content, SEO, and Meta ads strategy with consistent monthly reporting.',
    highlights: [
      { k: 'Revenue YoY', v: '+138%' },
      { k: 'Content Pieces', v: '120+' },
      { k: 'Channels', v: '4 Active' },
    ],
    icon: 'Rocket',
    accent: 'blue',
  },
  {
    id: 8,
    category: 'Tender Bidding',
    industry: 'Mechanical Maintenance Services',
    region: 'Gujarat',
    metric: '₹3Cr+',
    metricLabel: 'Business Secured',
    summary:
      'A mechanical maintenance services firm scaled to ₹3Cr+ of new business through targeted tender participation across PSU plants, industrial estates, and infrastructure clients — supported by our bid strategy and compliance review.',
    highlights: [
      { k: 'Business Secured', v: '₹3Cr+' },
      { k: 'Engagement', v: 'Ongoing' },
      { k: 'Sectors', v: 'PSU · Industrial · Infra' },
    ],
    icon: 'Cog',
    accent: 'amber',
  },
];

export const FAQS = [
  {
    q: 'What types of tenders does Arvanta Solutions handle?',
    a: 'We handle all categories — government (central and state), PSU, private sector, and international tenders. Our team has experience across construction, IT, infrastructure, healthcare, and logistics sectors.',
  },
  {
    q: 'How long does it take to prepare a tender bid?',
    a: 'Most standard bids take 5-10 business days. For complex multi-stage tenders we work on 2-3 week cycles. We offer 48-hour turnaround for urgent submissions when documentation is ready.',
  },
  {
    q: 'What digital growth services are included?',
    a: 'SEO (technical, on-page and off-page), content marketing, paid advertising (Google, Meta, LinkedIn), social media management, conversion rate optimization, and analytics & reporting dashboards.',
  },
  {
    q: 'Do you guarantee tender wins?',
    a: 'No ethical agency can guarantee wins. What we guarantee is a rigorous, professionally-crafted submission that maximizes your win probability. Our 94% success rate on qualified opportunities speaks for itself.',
  },
  {
    q: 'Can we use both tender bidding and digital growth services together?',
    a: 'Absolutely — in fact, we recommend it. A strong digital presence improves your credibility during tender evaluations, and tender wins generate case studies that fuel your digital marketing.',
  },
  {
    q: 'What is your pricing model?',
    a: 'We offer flexible engagement models — retainers, project-based fees, and success-linked pricing. Pricing depends on bid complexity, scope of digital services, and contract duration. Get a free quote for an exact estimate.',
  },
];

export const SERVICE_OPTIONS = [
  'Tender Bidding Support',
  'Digital Marketing & SEO',
  'Bid Strategy & Analysis',
  'Full-Spectrum Compliance',
  'Content Marketing',
  'Other',
];
